import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faDrawCircle,
  faDrawPolygon,
  faDrawSquare,
  faHand,
  faLasso,
} from "@fortawesome/pro-light-svg-icons";

import type { TerraDrawMode } from "../hooks";

export type DrawTool = {
  mode: TerraDrawMode;
  testId: string;
  icon: IconDefinition;
  /** Key in the `mapview` namespace naming the tool. */
  labelKey: string;
  /** Key in the `mapview` namespace describing how the tool is used. */
  helpKey: string;
};

/**
 * The drawing tools, in toolbar order. Shared by the toolbar and the help panel
 * so a tool can never appear in one without the other.
 */
export const DRAW_TOOLS: DrawTool[] = [
  {
    mode: "select",
    testId: "hand",
    icon: faHand,
    labelKey: "text_draw_tool_select",
    helpKey: "text_draw_help_select",
  },
  {
    mode: "circle",
    testId: "circle",
    icon: faDrawCircle,
    labelKey: "text_draw_tool_circle",
    helpKey: "text_draw_help_circle",
  },
  {
    mode: "polygon",
    testId: "polygon",
    icon: faDrawPolygon,
    labelKey: "text_draw_tool_polygon",
    helpKey: "text_draw_help_polygon",
  },
  {
    mode: "rectangle",
    testId: "rectangle",
    icon: faDrawSquare,
    labelKey: "text_draw_tool_rectangle",
    helpKey: "text_draw_help_rectangle",
  },
  {
    mode: "freehand",
    testId: "freehand",
    icon: faLasso,
    labelKey: "text_draw_tool_freehand",
    helpKey: "text_draw_help_freehand",
  },
];
